<template>

	<div>
		<h3>Detail</h3>

		<form ref="form">
			<ul class="list submission-list">
				<li class="size100" v-for="(row, index) in applicationData" :key="index">
					<div class="label">
						<span>{{row.label}} <template v-if="row.mandatory === '1'">*</template></span>
					</div>

					<div v-if="row.editable" class="form-field">
						<template v-if="row.type === 'Select'">
							<div class="selector">
								<select :name="row.machinename" :value="row.value" :required="row.mandatory">
									<option v-for="(option, index) in row.options" :value="option.value" :key="index">{{option.translations.en.value}}</option>
								</select>
							</div>
						</template>
						<template v-else-if="row.type === 'Textarea'">
							<textarea :name="row.machinename" :value="row.value" cols="30" rows="10" :required="row.mandatory"></textarea>
						</template>
						<template v-else-if="row.type === 'Radio'">
							<ul class="options">
								<li v-for="(option, index) in row.options" :key="index">
									<label class="flex-label">
										<input type="radio" :name="row.machinename" :value="option.value" :required="row.mandatory" :checked="checkCheckedState(row.value, option.value)">
										<span>{{option.translations.en.value}}</span>
									</label>
								</li>
							</ul>
						</template>
						<template v-else-if="row.type === 'Checkbox'">
							<ul class="options">
								<li v-for="(option, index) in row.options" :key="index">
									<label class="flex-label">
										<input type="checkbox" :name="row.machinename" :value="option.value" :required="row.mandatory" :checked="checkCheckedState(row.value, option.value)">
										<span>{{option.translations.en.value}}</span>
									</label>
								</li>
							</ul>
						</template>
					</div>

					<div v-else>
						<template v-if="row.type === 'E-mail'">
							<a :href="`mailto:${row.value}`">{{row.value}}</a>
						</template>
						<template v-else-if="row.type === 'Fileupload'">
							<!-- <a v-for="(file, index) in row.value" :key="index"
								:href="`/_uploads/${user.project.directory}/${entity.name}/${row.value}`"
								target="_blank">
								<i class="fa fa-file-alt"></i>
								{{file}}
							</a> -->
							<button v-for="(file, index) in row.value" :key="index" @click="downloadFileClickHandler"
								:data-url="`/cms/api/_uploads/${user.project.directory}/${entity.name}/`" :data-filename="row.value">
								<i class="fa fa-file-alt"></i>
								{{file}}
							</button>
						</template>
						<template v-else>
							{{row.value}}
						</template>
					</div>

				</li>
			</ul>
		</form>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'
import validation from '../../modules/forms/validation.js'

export default {
	name: 'submission-sidebar',
	props: {
		data: Object
	},

	watch: {
		data: function (newVal, oldVal) {
			this.entity = newVal.entity
			this.instanceUUID = newVal.instanceUUID
			this.market = newVal.market
		}
	},

	data () {
		return {
			entity: null,
			instanceUUID: null,
			market: null,
			applicationData: [],
			chosenInstance: null,
			formElements: null,
			user: this.$store.state.user
		}
	},

	created () {
		this.entity = this.data.entity
		this.instanceUUID = this.data.instanceUUID
		this.market = this.data.market

		// fetch form for this entity
		const entityUrl = '/cms/api/forms?entity=' + this.entity.id
		xhrModule.get(entityUrl, this.getFormCompleteHandler.bind(this))

		// fetch instance data
		const instanceUrl = '/cms/api/instances?uuid2=' + this.instanceUUID
		xhrModule.get(instanceUrl, this.getInstancesCompleteHandler.bind(this))
	},

	methods: {
		getFormCompleteHandler (data) {
			const elements = data.data[Object.keys(data.data)[0]].elements
			this.formElements = Object.values(elements)
			this.prepareData()
		},

		getInstancesCompleteHandler (data) {
			// pick instance with the right market
			for (let key in data.data) {
				const instanceMarket = data.data[key].market
				if (instanceMarket === this.market.id) {
					this.chosenInstance = data.data[key]
					this.chosenInstanceData = data.data[key].data
					this.prepareData()
					break
				}
			}
		},

		prepareData () {
			if (this.chosenInstanceData && this.formElements) {
				for (let i = 0; i < this.formElements.length; i++) {
					const formElementMachineName = this.formElements[i].property.name

					let obj = {
						label: this.formElements[i].property.translations.en.value,
						mandatory: this.formElements[i].property.settings.mandatory.value,
						type: this.formElements[i].property.settings.type.value,
						value: null,
						machinename: this.formElements[i].property.name
					}

					if (this.formElements[i].property.settings.editablesubmission.value) {
						obj.editable = this.formElements[i].property.settings.editablesubmission.value
					}

					if (this.formElements[i].options) {
						let optionsArr = Object.values(this.formElements[i].options)
						optionsArr.sort((a, b) => a.priority > b.priority ? 1 : -1)
						obj.options = optionsArr

						// when there is no value defined yet we can set the first option as default value
						// if (!obj.value || obj.value === '') obj.value = optionsArr[0].value
					}

					for (let key in this.chosenInstanceData) {
						if (key === formElementMachineName) {
							obj.value = this.chosenInstanceData[key].value
							break
						}
					}

					this.applicationData.push(obj)
					if (i === this.formElements.length - 1) {
						// console.log(this.applicationData)
						// console.log(this.user)
					}
				}
			}
		},

		save () {
			const valid = validation.validate(this.$refs['form'], false, [])
			if (!valid) return

			let formData = new FormData(this.$refs['form'])
			formData = general.convertFormDataToObject(formData)

			// gather data and post instances
			let propertiesArr = []
			let payload = {
				'entity': this.entity.id,
				'uuid': this.chosenInstance.uuid,
				'instance': [{
					'id': this.chosenInstance.id,
					'properties': propertiesArr,
					'market': this.market.id,
					'state': this.chosenInstance.state
				}]
			}

			// add existing propeties to properties array
			// loop over entity properties and add values based on existing instance data and formdata
			for (let prop in this.entity.properties) {
				let propObj = {
					'id': 0,
					'property': this.entity.properties[prop].id,
					'value': ''
				}

				// loop over existing instance props
				for (let instanceProp in this.chosenInstance.data) {
					if (prop === instanceProp) {
						propObj.id = this.chosenInstance.data[instanceProp].id
						propObj.value = this.chosenInstance.data[instanceProp].value
						break
					}
				}

				// loop over formdata
				for (let formProp in formData) {
					if (prop === formProp) {
						propObj.value = formData[formProp]
						break
					}
				}

				propertiesArr.push(propObj)
			}

			const jsondata = JSON.stringify(payload)
			const url = '/cms/api/instances/save'
			xhrModule.post(url, jsondata, this.postInstanceCompleteHandler.bind(this))
		},

		postInstanceCompleteHandler (data) {
			this.data.saveCallbackFunction()
			general.saveAnimation()
			this.$parent.toggle()
		},

		checkCheckedState (savedValue, optionValue) {
			const isJson = general.isJson(savedValue)
			const savedValues = isJson ? JSON.parse(savedValue) : [savedValue]

			if (savedValues) {
				return savedValues.includes(optionValue)
			} else {
				return false
			}
		},

		downloadFileClickHandler (e) {
			e.preventDefault()

			const target = e.currentTarget

			const downloadURL = target.getAttribute('data-url')
			this.filename = target.getAttribute('data-filename')
			xhrModule.download(downloadURL + this.filename, this.downloadCompleteHandler.bind(this))
		},

		downloadCompleteHandler (data) {
			console.log(data)
			var blob = data.blob

			var file = window.URL.createObjectURL(blob)

			var a = document.createElement('a')
			a.href = file
			a.download = this.filename
			a.click()
			a.remove()
		}
	}
}

</script>
